(() => {
  const body = document.body;
  const intro = document.querySelector('[data-mf-intro]');
  const heroLogo = document.querySelector('[data-mf-hero-logo]');
  if (intro) {
    const dismissIntro = () => {
      intro.classList.add('is-leaving');
      heroLogo?.classList.add('is-visible');
      window.setTimeout(() => intro.remove(), 450);
    };
    window.setTimeout(dismissIntro, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 1400);
  }
  if (heroLogo) {
    const updateHeroLogo = () => {
      heroLogo.classList.toggle('is-hidden', window.scrollY >= 30);
    };
    window.addEventListener('scroll', updateHeroLogo, { passive: true });
    updateHeroLogo();
  }
  const homepageHero = document.querySelector('.mf-fullscreen-hero');
  if (homepageHero) {
    const updateHeaderTone = () => {
      body.classList.toggle('mf-header-light', window.scrollY < homepageHero.offsetHeight - 54);
    };
    window.addEventListener('scroll', updateHeaderTone, { passive: true });
    window.addEventListener('resize', updateHeaderTone);
    updateHeaderTone();
  }
  const searchOverlay = document.querySelector('[data-mf-search-overlay]');
  const searchInput = document.querySelector('[data-mf-search-input]');
  const predictiveResults = document.querySelector('[data-mf-predictive-results]');
  const searchClear = document.querySelector('[data-mf-search-clear]');
  const newsletterModal = document.querySelector('[data-mf-newsletter-modal]');
  const newsletterDialog = document.querySelector('[data-mf-newsletter-dialog]');
  const keepSidebarAboveFooter = () => {
    const sidebarContents = document.querySelectorAll('.mf-sidebar__inner, .mf-home-sidebar__inner');
    const footer = document.querySelector('.mf-footer');
    if (!sidebarContents.length || !footer || window.matchMedia('(max-width: 749px)').matches) return;
    sidebarContents.forEach((sidebarContent) => {
      sidebarContent.style.removeProperty('transform');
      const offset = Math.min(0, footer.getBoundingClientRect().top - sidebarContent.getBoundingClientRect().bottom);
      sidebarContent.style.transform = `translateY(${Math.floor(offset)}px)`;
    });
  };
  window.addEventListener('scroll', keepSidebarAboveFooter, { passive: true });
  window.addEventListener('resize', keepSidebarAboveFooter);
  keepSidebarAboveFooter();
  const setSearch = (open) => {
    searchOverlay?.classList.toggle('is-open', open);
    searchOverlay?.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('search-open', open);
    if (open) searchInput?.focus();
  };
  const setNewsletterModal = (open) => {
    newsletterModal?.classList.toggle('is-open', open);
    newsletterModal?.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('newsletter-open', open);
    if (open) newsletterDialog?.querySelector('input[type="email"]')?.focus();
  };
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-mf-newsletter-open]')) { event.preventDefault(); setNewsletterModal(true); }
    if (event.target.closest('[data-mf-newsletter-close]')) setNewsletterModal(false);
    const menuTrigger = event.target.closest('[data-mf-menu-toggle]');
    if (menuTrigger) {
      body.classList.toggle('menu-open');
      menuTrigger.setAttribute('aria-expanded', String(body.classList.contains('menu-open')));
    }
    const navToggle = event.target.closest('[data-mf-nav-toggle]');
    if (navToggle) {
      const group = navToggle.closest('.mf-nav__group');
      const collapsed = group?.classList.toggle('is-collapsed');
      if (!collapsed) {
        group?.closest('.mf-nav')?.querySelectorAll('.mf-nav__group:not(.is-collapsed)').forEach((otherGroup) => {
          if (otherGroup === group || !otherGroup.querySelector('[data-mf-nav-toggle]')) return;
          otherGroup.classList.add('is-collapsed');
          const otherToggle = otherGroup.querySelector('[data-mf-nav-toggle]');
          const otherLabel = otherToggle.querySelector('.mf-nav__group-label')?.textContent.trim() || 'section';
          otherToggle.setAttribute('aria-expanded', 'false');
          otherToggle.setAttribute('aria-label', `Expand ${otherLabel}`);
          otherToggle.querySelector('.mf-nav__group-indicator').textContent = '+';
        });
      }
      navToggle.setAttribute('aria-expanded', String(!collapsed));
      navToggle.querySelector('.mf-nav__group-indicator').textContent = collapsed ? '+' : '−';
      navToggle.setAttribute('aria-label', `${collapsed ? 'Expand' : 'Collapse'} ${navToggle.querySelector('.mf-nav__group-label')?.textContent.trim() || 'section'}`);
      keepSidebarAboveFooter();
    }
    if (event.target.closest('[data-mf-search-toggle]')) setSearch(true);
    if (event.target.closest('[data-mf-search-close]')) setSearch(false);
    if (event.target.closest('[data-mf-search-clear]')) {
      searchInput.value = '';
      searchClear?.classList.remove('is-visible');
      predictiveResults.innerHTML = '';
      searchInput.focus();
    }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { setSearch(false); setNewsletterModal(false); } });
  let searchTimer;
  const escapeHtml = (value) => value.replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
  const renderPredictiveProducts = (products, query) => {
    const searchAll = `<button class="mf-predictive-all" type="submit">Search for “${escapeHtml(query)}”</button>`;
    const items = products.map((product) => {
      const image = typeof product.image === 'string' ? product.image : product.image?.url;
      const thumbnail = image ? `<img src="${escapeHtml(image)}" alt="" width="50" height="81" loading="lazy">` : '';
      return `<li><a class="mf-predictive-item" href="${escapeHtml(product.url)}">${thumbnail}<span>${escapeHtml(product.title)}</span></a></li>`;
    }).join('');
    predictiveResults.innerHTML = products.length
      ? `<section class="mf-predictive-section" aria-label="Products"><h2 class="mf-predictive-section__heading">Products</h2><ul class="mf-predictive-list">${items}</ul>${searchAll}</section>`
      : `<p class="mf-predictive-empty">No products found.</p>${searchAll}`;
  };
  const getFallbackSearchProducts = async (query) => {
    const form = searchInput.closest('form');
    const response = await fetch(`${form.action}?q=${encodeURIComponent(query)}&type=product`);
    if (!response.ok) throw new Error('Search fallback unavailable');
    const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
    const products = new Map();
    documentResult.querySelectorAll('a[href*="/products/"]').forEach((item) => {
      const url = item.href;
      const title = item.textContent.trim() || item.getAttribute('aria-label') || '';
      if (!url || !title || products.has(url)) return;
      products.set(url, { url, title, image: item.querySelector('img')?.src || item.closest('article, li, div')?.querySelector('img')?.src || '' });
    });
    return [...products.values()].slice(0, 5);
  };
  searchInput?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    const query = searchInput.value.trim();
    searchClear?.classList.toggle('is-visible', Boolean(query));
    if (!query) { predictiveResults.innerHTML = ''; return; }
    searchTimer = window.setTimeout(async () => {
      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`);
        if (!response.ok) throw new Error('Predictive search unavailable');
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        if (query === searchInput.value.trim()) renderPredictiveProducts(products, query);
      } catch (error) {
        try {
          const products = await getFallbackSearchProducts(query);
          if (query === searchInput.value.trim()) renderPredictiveProducts(products, query);
        } catch (fallbackError) {
          if (query === searchInput.value.trim()) renderPredictiveProducts([], query);
        }
      }
    }, 200);
  });

  const cartDrawer = document.querySelector('[data-mf-cart-drawer]');
  const cartPanel = document.querySelector('[data-mf-cart-panel]');
  const cartBody = document.querySelector('[data-mf-cart-body]');
  const cartFooter = document.querySelector('[data-mf-cart-footer]');
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const setCart = (open) => {
    cartDrawer?.classList.toggle('is-open', open);
    cartDrawer?.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('cart-open', open);
    if (open) cartPanel?.focus();
  };
  const updateCartCount = (count) => document.querySelectorAll('[data-mf-cart-count]').forEach((element) => { element.textContent = count; });
  const syncCartCheckout = (itemCount) => {
    const checkout = cartFooter?.querySelector('[data-mf-cart-checkout]');
    const terms = cartFooter?.querySelector('[data-mf-cart-terms]');
    if (!checkout) return;
    checkout.disabled = !itemCount || !terms?.checked;
    checkout.setAttribute('aria-disabled', String(checkout.disabled));
  };
  const renderCart = (cart) => {
    if (!cartBody || !cartFooter) return;
    updateCartCount(cart.item_count);
    if (!cart.item_count) {
      cartBody.innerHTML = '<div class="mf-cart-empty"><h2>YOUR CART IS EMPTY</h2><button type="button" class="mf-cart-continue" data-mf-cart-close>Continue shopping</button><div class="mf-cart-login"><strong>HAVE AN ACCOUNT?</strong><p><a href="/account/login">Log in</a> to check out faster.</p></div></div>';
    } else {
      cartBody.innerHTML = `<ul class="mf-cart-items" data-mf-cart-items>${cart.items.map((item) => `<li class="mf-cart-item" data-mf-cart-line="${item.key}"><a href="${item.url}" class="mf-cart-item__image">${item.image ? `<img src="${item.image}" alt="" width="80" height="122">` : ''}</a><div class="mf-cart-item__details"><a href="${item.url}">${escapeHtml(item.product_title)}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<span>${escapeHtml(item.variant_title)}</span>` : ''}<span>${formatMoney(item.final_price)}</span><div class="mf-cart-item__controls"><button type="button" data-mf-cart-change="-1" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-mf-cart-change="1" aria-label="Increase quantity">+</button><button type="button" data-mf-cart-remove>REMOVE</button></div></div></li>`).join('')}</ul>`;
    }
    cartFooter.querySelector('[data-mf-cart-total]').textContent = formatMoney(cart.total_price);
    cartFooter.dataset.mfCartItemCount = String(cart.item_count);
    syncCartCheckout(cart.item_count);
  };
  const getCart = async () => { const response = await fetch('/cart.js'); if (!response.ok) throw new Error('Unable to load cart'); return response.json(); };
  const changeCart = async (key, quantity) => { const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) }); if (!response.ok) throw new Error('Unable to update cart'); const cart = await response.json(); renderCart(cart); };
  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-mf-cart-toggle]')) { event.preventDefault(); setCart(true); return; }
    if (event.target.closest('[data-mf-cart-close]')) { setCart(false); return; }
    const line = event.target.closest('[data-mf-cart-line]');
    if (!line) return;
    const quantityDelta = event.target.closest('[data-mf-cart-change]')?.dataset.mfCartChange;
    const remove = event.target.closest('[data-mf-cart-remove]');
    if (!quantityDelta && !remove) return;
    const quantity = remove ? 0 : Math.max(0, Number(line.querySelector('.mf-cart-item__controls span').textContent) + Number(quantityDelta));
    try { await changeCart(line.dataset.mfCartLine, quantity); } catch (error) { window.location.assign('/cart'); }
  });
  cartFooter?.querySelector('form')?.addEventListener('submit', (event) => {
    const terms = cartFooter.querySelector('[data-mf-cart-terms]');
    if (terms && !terms.checked) {
      event.preventDefault();
      terms.focus();
      cartFooter.querySelector('.mf-cart-terms')?.classList.add('has-error');
    }
  });
  cartFooter?.querySelector('[data-mf-cart-terms]')?.addEventListener('change', (event) => {
    cartFooter.querySelector('.mf-cart-terms')?.classList.toggle('has-error', !event.target.checked);
    syncCartCheckout(Number(cartFooter.dataset.mfCartItemCount || 0));
  });
  getCart().then(renderCart).catch(() => {});
  document.querySelectorAll('[data-mf-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[data-mf-add-to-cart]');
    if (button?.disabled) return;
    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add product');
      renderCart(await getCart());
      setCart(true);
    } catch (error) { form.submit(); } finally { button.disabled = false; }
  }));

  document.querySelectorAll('[data-mf-card]').forEach((card) => {
    const media = card.querySelector('.mf-card__media');
    if (!media || media.querySelectorAll('.mf-card__image').length < 2) return;
    let startX = 0;
    media.addEventListener('pointerdown', (event) => { startX = event.clientX; });
    media.addEventListener('pointerup', (event) => {
      const delta = event.clientX - startX;
      if (Math.abs(delta) < 32) return;
      card.classList.toggle('mf-card--second-media', delta < 0);
    });
  });

  const homeSidebar = document.querySelector('[data-mf-home-sidebar]');
  const homePrimaryMedia = document.querySelector('.mf-home-media--primary');
  if (homeSidebar && homePrimaryMedia) {
    const setHomeSidebarVisibility = () => {
      const isDesktop = window.matchMedia('(min-width: 750px)').matches;
      const primaryTop = homePrimaryMedia.getBoundingClientRect().top;
      body.classList.toggle('mf-home-sidebar-visible', isDesktop && primaryTop <= 60);
    };
    window.addEventListener('scroll', setHomeSidebarVisibility, { passive: true });
    window.addEventListener('resize', setHomeSidebarVisibility);
    setHomeSidebarVisibility();
  }

  document.querySelectorAll('[data-mf-product]').forEach((productRoot) => {
    productRoot.querySelectorAll('.mf-product__section-copy--details p').forEach((line) => {
      line.textContent = line.textContent.replace(/([A-Za-z])(?=\d+(?:\.\d+)?%)/g, '$1 ');
    });
    const track = productRoot.querySelector('[data-mf-gallery-track]');
    const slides = productRoot.querySelectorAll('[data-mf-gallery-slide]');
    const galleryCount = productRoot.querySelector('[data-mf-gallery-count]');
    let activeSlide = 0;
    const setSlide = (next) => {
      if (!track || !slides.length) return;
      activeSlide = (next + slides.length) % slides.length;
      if (window.matchMedia('(max-width: 749px)').matches) slides[activeSlide].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeSlide));
      if (galleryCount) galleryCount.textContent = `${activeSlide + 1}/${slides.length}`;
    };
    productRoot.querySelector('[data-mf-gallery-next]')?.addEventListener('click', () => setSlide(activeSlide + 1));
    productRoot.querySelector('[data-mf-gallery-previous]')?.addEventListener('click', () => setSlide(activeSlide - 1));
    track?.addEventListener('scroll', () => {
      if (!window.matchMedia('(max-width: 749px)').matches || !slides.length) return;
      const nearest = [...slides].reduce((best, slide, index) => Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - track.scrollLeft) ? index : best, 0);
      if (nearest !== activeSlide) { activeSlide = nearest; slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeSlide)); if (galleryCount) galleryCount.textContent = `${activeSlide + 1}/${slides.length}`; }
    }, { passive: true });

    const variantSelect = productRoot.querySelector('[data-mf-variant-select]');
    const addToCart = productRoot.querySelector('[data-mf-add-to-cart]');
    // Colour is displayed before size, while Shopify variant options retain their
    // Admin order. Build the selection array from each option's original position
    // instead of its visual DOM order.
    const selections = [];
    productRoot.querySelectorAll('[data-mf-option]').forEach((group) => {
      selections[Number(group.dataset.mfOption)] = group.querySelector('.is-selected')?.dataset.value || '';
    });
    productRoot.querySelectorAll('[data-mf-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-mf-option]');
        const index = Number(group.dataset.mfOption);
        selections[index] = button.dataset.value;
        group.querySelectorAll('[data-mf-option-value]').forEach((value) => value.classList.toggle('is-selected', value === button));
        const matching = [...variantSelect.options].find((option) => option.dataset.options.split('||').every((value, position) => value === selections[position]));
        if (!matching) return;
        variantSelect.value = matching.value;
        const available = matching.dataset.available === 'true';
        addToCart.disabled = !available;
        addToCart.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
      });
    });
  });
})();
